export default "__VITE_ASSET__DnDIdhmS__"